export default __webpack_public_path__ + "static/media/take-selfie-example-1.285d9c3c.png";